import React from 'react'
import { Box, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { Container, Row, Col, Image, ListGroup  } from 'react-bootstrap'
import logo from '../Assets/Images/LogoWhite.png';
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAddressBook, faAddressCard,faEnvelopeOpen,faComments,faFileVideo,faCalendarCheck,faCircleQuestion } from '@fortawesome/free-regular-svg-icons'
import { faHouseChimney, faPlaneDeparture, faUsersBetweenLines, faPlaneCircleCheck, faMapPin, faBook, faMobileScreenButton,faPeopleGroup,faPrint,faLandmark,faUserTie,faTruckPlane,faPersonWalkingLuggage, faClipboardQuestion} from '@fortawesome/free-solid-svg-icons';
import { faFacebookF,faInstagram,faXTwitter,faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { motion } from 'framer-motion'
import NewsLetterFooter from '../Homepage/NewsLetterFooter';

const Footer = () => {
  let navigate  = useNavigate();
  return (
    <>
    <NewsLetterFooter />
      <Box className="cstFooter">
            <Container>
              <Box className="footerOverlay">
              </Box>
                <Row className='py-5'>
                    <Col lg={4}>
                    <motion.div
                        initial={{ x: -100, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        exit={{ x: 100, opacity: 0 }}
                        transition={{ duration: 1, ease: "easeInOut" }}
                        viewport={{ once: true, amount: 0.1  }}
                    >
                                      <Box className="footerBrand">
                            <Image src={logo} className='img-fluid'></Image>
                            <Typography variant="body1" component='p'>Shankh Air will connect major cities within and outside Uttar Pradesh, boosting regional connectivity and economic growth. Initial routes include Lucknow, Varanasi, Gorakhpur, and key metros like Delhi, Mumbai, and Bengaluru</Typography>
                        </Box>
                    </motion.div>
                    </Col>
                    <Col lg={2}>
                    <motion.div
                        initial={{ x: -100, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        exit={{ x: 100, opacity: 0 }}
                        transition={{ duration: 1, ease: "easeInOut" }}
                        viewport={{ once: true, amount: 0.1  }}
                    >
                      <Box className="footerSection">
                        <Typography variant="body1" component='h2'>Explore</Typography>
                        <Box className="footerLinks">
                        <ListGroup as='ul' className='cstList'>
                          <ListGroup.Item as='li'>
                            <Link to='/'><FontAwesomeIcon icon={faHouseChimney} /> Home</Link>
                          </ListGroup.Item>
                          <ListGroup.Item as='li'>
                            <Link to='/about'><FontAwesomeIcon icon={faAddressBook} /> About Us</Link>
                          </ListGroup.Item>
                          <ListGroup.Item as='li'>
                          <Link
                              to="/#bookNow"
                              onClick={() => {
                                navigate('/');
                                setTimeout(() => {
                                  const section = document.getElementById('bookNow');
                                  if (section) {
                                    const yOffset = -150;
                                    const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
                                    window.scrollTo({ top: y, behavior: 'smooth' });
                                  }
                                }, 200);
                              }}
                            >
                              <FontAwesomeIcon icon={faPlaneDeparture} /> Book Flight
                            </Link>
                          </ListGroup.Item>
                          <ListGroup.Item as='li'>
                            <Link to='/ourTeam' ><FontAwesomeIcon icon={faPeopleGroup} />Our Team</Link>
                          </ListGroup.Item>
                          <ListGroup.Item as='li'>
                            <Link to='/contact' ><FontAwesomeIcon icon={faComments} />Contact Us</Link>
                          </ListGroup.Item>
                          <ListGroup.Item as='li'>
                            <Link to='/' onClick={(e) => e.preventDefault()}><FontAwesomeIcon icon={faFileVideo} />Media Center</Link>
                          </ListGroup.Item>
                        </ListGroup>
                        </Box>
                      </Box>
                      </motion.div>
                    </Col>
                    <Col lg={2}>
                    <motion.div
                        initial={{ x: 100, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        exit={{ x: 100, opacity: 0 }}
                        transition={{ duration: 1, ease: "easeInOut" }}
                        viewport={{ once: true, amount: 0.1  }}
                    >
                      <Box className="footerSection">
                        <Typography variant="body1" component='h2'>Links</Typography>
                        <Box className="footerLinks">
                        <ListGroup as='ul' className='cstList'>
                          <ListGroup.Item as='li'>
                            <Link to='/' onClick={(e) => e.preventDefault()}><FontAwesomeIcon icon={faBook} />Tarrifs Sheet</Link>
                          </ListGroup.Item>
                          <ListGroup.Item as='li'>
                            <Link to='/' onClick={(e) => e.preventDefault()}><FontAwesomeIcon icon={faAddressCard} />Carriage Conditions</Link>
                          </ListGroup.Item>
                          <ListGroup.Item as='li'>
                            <Link to='/' onClick={(e) => e.preventDefault()}><FontAwesomeIcon icon={faPrint} />Fares Sheet</Link>
                          </ListGroup.Item>
                          <ListGroup.Item as='li'>
                            <Link to='/' onClick={(e) => e.preventDefault()}><FontAwesomeIcon icon={faCalendarCheck} />Flights Schedule</Link>
                          </ListGroup.Item>
                          <ListGroup.Item as='li'>
                            <Link to='/' onClick={(e) => e.preventDefault()}><FontAwesomeIcon icon={faPlaneCircleCheck} />Passenger Charter</Link>
                          </ListGroup.Item>
                          <ListGroup.Item as='li'>
                            <Link to='/faq'><FontAwesomeIcon icon={faCircleQuestion} />FAQs</Link>
                          </ListGroup.Item>
                        </ListGroup>
                        </Box>
                      </Box>
                      </motion.div>
                    </Col>
                    <Col lg={2}>
                    <motion.div
                        initial={{ x: 100, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        exit={{ x: 100, opacity: 0 }}
                        transition={{ duration: 1, ease: "easeInOut" }}
                        viewport={{ once: true, amount: 0.1  }}
                    >
                      <Box className="footerSection">
                        <Typography variant="body1" component='h2'>Join Us</Typography>
                        <Box className="footerLinks">
                        <ListGroup as='ul' className='cstList'>
                          <ListGroup.Item as='li'>
                            <Link to='/careers'><FontAwesomeIcon icon={faLandmark} />Careers</Link>
                          </ListGroup.Item>
                          <ListGroup.Item as='li'>
                            <Link to='/' onClick={(e) => e.preventDefault()}><FontAwesomeIcon icon={faUserTie} />Pilots</Link>
                          </ListGroup.Item>
                          <ListGroup.Item as='li'>
                            <Link to='/' onClick={(e) => e.preventDefault()}><FontAwesomeIcon icon={faUsersBetweenLines} />Cabin Crew</Link>
                          </ListGroup.Item>
                          <ListGroup.Item as='li'>
                            <Link to='/' onClick={(e) => e.preventDefault()}><FontAwesomeIcon icon={faTruckPlane} />Airport operations</Link>
                          </ListGroup.Item>
                          <ListGroup.Item as='li'>
                            <Link to='/engineering' ><FontAwesomeIcon icon={faPersonWalkingLuggage} />Engineering</Link>
                          </ListGroup.Item>
                          <ListGroup.Item as='li'>
                            <Link to='/' onClick={(e) => e.preventDefault()}><FontAwesomeIcon icon={faClipboardQuestion} />Why Join us</Link>
                          </ListGroup.Item>
                        </ListGroup>
                        </Box>
                      </Box>
                      </motion.div>
                    </Col>
                    <Col lg={2}>
                    <motion.div
                        initial={{ x: 100, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        exit={{ x: 100, opacity: 0 }}
                        transition={{ duration: 1, ease: "easeInOut" }}
                        viewport={{ once: true, amount: 0.1  }}
                    >
                      <Box className="footerSection">
                        <Typography variant="body1" component='h2'>Contact</Typography>
                        <Box className="footerLinks">
                        <ListGroup as='ul' className='cstList'>
                          <ListGroup.Item as='li'>
                            <Box as='a' href="tel:1234567890"><FontAwesomeIcon icon={faMobileScreenButton} />+91 99351-52025</Box>
                          </ListGroup.Item>
                          <ListGroup.Item as='li'>
                            <Box as='a' href="mailto:contactus@shankhair.com"><FontAwesomeIcon icon={faEnvelopeOpen} />contactus@shankhair.com</Box>
                          </ListGroup.Item>
                          <Box className="address">
                            <Typography variant="body1" component='p'><FontAwesomeIcon icon={faMapPin} /> Headquarter</Typography>
                            <Typography variant="body1" component='p'>Gomti Nagar Extension, Lucknow, Uttar Pradesh (India)</Typography>
                            {/* <Typography variant="body1" component='p'>Headoffice</Typography><Typography variant="body1" component='p'>Headquarter</Typography>
                            <Typography variant="body1" component='p'>1/8,Sector-1, Gomti Nagar Extension, Lucknow, Uttar Pradesh (India)</Typography> */}
                          </Box>
                        </ListGroup>
                        <Box className="footerSocial">
                          <Link className="icon" to="#" onClick={()=> window.open("https://www.facebook.com/ShankhAirlines")}><FontAwesomeIcon icon={faFacebookF} /></Link>
                          <Link className="icon" to="#" onClick={() => window.open("https://www.instagram.com/shankh.air/?hl=en")}><FontAwesomeIcon icon={faInstagram} /></Link>
                          <Link className="icon"><FontAwesomeIcon icon={faXTwitter} /></Link>
                          <Link className="icon" to="#" onClick={() => window.open("https://in.linkedin.com/company/shankh-air")}><FontAwesomeIcon icon={faLinkedinIn} /></Link>
                        </Box>
                        </Box>
                      </Box>
                      </motion.div>
                    </Col>
                </Row>
                <Box className="footerCopyright py-4">
                  <Typography variant="body1" component='p'>© 2025 Shankh Air. All rights reserved.</Typography>
                </Box>
            </Container>
      </Box>
    </>
  )
}

export default Footer
